<template>
  <div class="animated fadeIn" v-if="show">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        Top log {{so.perPage}}
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WEBCastle</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Dashboard</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail_search -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label">Date</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <date-picker @change="refresh" v-model="so.opt.from" style="width: 80%" :lang="datepicker" :confirm="false" :first-day-of-week="1"></date-picker>
        </b-col>
        <b-col class="col-xl-1 col-md-12 d-felx align-self-center">
          ~
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <date-picker @change="refresh" v-model="so.opt.to" style="width: 80%" :lang="datepicker" :confirm="false" :first-day-of-week="1"></date-picker>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-4">
          <label class="col-form-label">Method</label>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <b-form-group>
            <input type="radio" id="GET" value="GET" v-model="so.opt.method" @click="so.sk='request'">
            <label class="col-form-label" for="GET">GET</label>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <b-form-group>
            <input type="radio" id="POST" value="POST" v-model="so.opt.method" @click="so.sk='request'">
            <label for="POST">POST</label>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-4">
          <label class="col-form-label">Response</label>
        </b-col>
        <b-col classs="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <b-form-group>
            <input class="mt-3" type="radio" id="DetectionOnly" value=0 v-model="so.opt.is_block" @click="so.sk='is_block'">
            <label for="DetectionOnly">
              <b-badge variant="warning">Detection</b-badge>
            </label>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <b-form-group>
            <input class="mt-3" type="radio" id="Block" value=1 v-model="so.opt.is_block" @click="so.sk='is_block'">
            <label for="Block">
              <b-badge variant="danger">Block</b-badge>
            </label>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label">Attacker</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input type="text" id="ph_remote_addr" v-model="so.opt.remote_addr" :placeholder="'typing attacker'"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label">Target</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input type="text" id="ph_target" v-model="so.opt.target" :placeholder="'typing target'"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label">Detect message</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input type="text" id="ph_message" v-model="so.opt.message" :placeholder="'typing detect message'"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label">URI</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input type="text" id="ph_uri" v-model="so.opt.uri" :placeholder="'typing URI'"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-4">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh">Search</b-button>
          <b-button size="sm" variant="warning" @click="reset">Reset</b-button>
          <b-button size="sm" variant="secondary" @click="so.sv=so.sk=''; so.adv = false; reset">Close</b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail_search -->
    <div class="d-flex flex-wrap align-items-center">      
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <div class="mr-auto mb7"></div>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mb7 mt-2 mr-2">
            <button class="btn btn-sm btn-primary" @click="pause" size="sm">
              <span :class="`fa fa-refresh ${sync.th && !sync.stop ? 'fa-spin' : ''}`"></span>
              Pause
            </button>
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mb7 form-inline">
            <label class="col-form-label mr-2" for="sel3" v-b-tooltip.hover title="can see the log real-time">Refresh interval</label>
            <select class="form-control mr-2" name="sel3" id="sel3" v-model="sync.interval" @change="refresh">
              <option disabled value="15">Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <label class="col-form-label mr-2" for="sel3">sec</label>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="10">Show count : Default 10</option>
              <option value=15>15</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list"
            show-empty empty-text="not found" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" @row-clicked="goDetail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
            <template slot="remote_addr" slot-scope="row">{{row.item.remote_addr ? row.item.remote_addr : '-'}}</template>
            <template slot="target" slot-scope="row">{{row.item.target ? row.item.target : '-'}}</template>
            <template slot="protocol" slot-scope="row">{{row.item.protocol ? row.item.protocol : '-'}}</template>
            <template slot="method" slot-scope="row">{{row.item.method ? row.item.method : '-'}}</template>
            <template slot="is_block" slot-scope="row">
              <b-badge v-if="row.item.is_block" variant="danger">Block</b-badge>
              <b-badge v-else variant="warning">Detect</b-badge>
            </template>
            <template slot="uri" slot-scope="row">{{(row.item.uri ? row.item.uri : '-') | truncate(60)}}</template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>